import {
  apiRequest,
  positionList,
  positionDetail,
  positionEselon,
  positionRank,
  positionWorkUnit,
  positionUpdate,
  positionCreate,
  positionDraft,
  positionDelete,
} from "../../../../../services/adapters/master/positionService";

class IndexRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionDetail,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchEselon = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionEselon,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchRank = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionRank,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchWorkUnit = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionWorkUnit,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      positionUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      positionCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchDraft = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionDraft,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchDelete = async (query) => {
    return await apiRequest(
      "post",
      positionDelete,
      {
        body: query,
      },
      true
    );
  };
}

export default IndexRepository;
